export enum VPOReportCompletedActionsTypes {
  FETCH_REQUEST = 'VPO_REPORT_COMPLETED_ACTIONS/FETCH_REQUEST',
  FETCH_SUCCESS = 'VPO_REPORT_COMPLETED_ACTIONS/FETCH_SUCCESS',
  FETCH_FAILURE = 'VPO_REPORT_COMPLETED_ACTIONS/FETCH_FAILURE',
  CLEAR_DATA = 'VPO_REPORT_COMPLETED_ACTIONS/CLEAR_DATA',
}

export interface FetchVPOReportCompletedActionsRequest {
  type: VPOReportCompletedActionsTypes.FETCH_REQUEST;
  payload: {
    filters: any;
  };
}

export interface FetchVPOReportCompletedActionsSuccess {
  type: VPOReportCompletedActionsTypes.FETCH_SUCCESS;
  payload: {
    data: any;
  };
}

export interface FetchVPOReportCompletedActionsFailure {
  type: VPOReportCompletedActionsTypes.FETCH_FAILURE;
  payload: { error: string };
}

export interface ClearVPOReportCompletedActionsData {
  type: VPOReportCompletedActionsTypes.CLEAR_DATA;
}

export type VPOReportCompletedActionsAction =
  | FetchVPOReportCompletedActionsRequest
  | FetchVPOReportCompletedActionsSuccess
  | FetchVPOReportCompletedActionsFailure
  | ClearVPOReportCompletedActionsData;

export const fetchVPOReportCompletedActions = (filters: any): FetchVPOReportCompletedActionsRequest => {
  const action = {
    type: VPOReportCompletedActionsTypes.FETCH_REQUEST,
    payload: { filters },
  };
  return action;
};

export const fetchVPOReportCompletedActionsSuccess = (data: any): FetchVPOReportCompletedActionsSuccess => ({
  type: VPOReportCompletedActionsTypes.FETCH_SUCCESS,
  payload: { data },
});

export const fetchVPOReportCompletedActionsFailure = (error: string): FetchVPOReportCompletedActionsFailure => ({
  type: VPOReportCompletedActionsTypes.FETCH_FAILURE,
  payload: { error },
});

export const clearVPOReportCompletedActionsData = (): ClearVPOReportCompletedActionsData => ({
  type: VPOReportCompletedActionsTypes.CLEAR_DATA,
});
